export default {
  id: 205,
  title: "Target #205 - Magneto's helmet",
  url: 'https://cssbattle.dev/play/205',
  colors: ['#232323', '#AF3A3A'],
  solution:
    '<p a><p b><p c><p d><p e><p f><style>p[b],p[c]{border-radius:50%}p[d],p[e]{top:220;width:44;height:44;background:#af3a3a}p[a],p[c],p[d],p[e]{background:#af3a3a}body,p[b],p[f]{background:#232323}p{position:fixed;margin:0}p[a]{top:34;left:120;width:160;height:214;border-radius:1in 1in 0 0}p[b]{top:87;left:140;width:120;height:70}p[c]{top:52;left:160;width:80;height:50}p[d]{left:129;rotate:32deg}p[e]{right:129;rotate:-32deg}p[f]{top:140;left:165;width:70;height:108',
}
